export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/take-cargocode' */ './TakeCargoCode'
  );
